import React from 'react';
export const useBooleanRateLimited = (initialBool = false, debouncedTimeout = 500, throttledTimeout = 300) => {
  const [bool, setBool] = React.useState(initialBool);
  const debouncedHandle = React.useRef();
  const throttledHandle = React.useRef();
  const debouncedSetter = (newBool, instant) => newBool ? setToTrue(instant) : setToFalse(instant);
  const setToTrue = instant => {
    if (debouncedHandle.current) {
      window.clearTimeout(debouncedHandle.current);
      debouncedHandle.current = undefined;
    }
    if (instant) {
      setBool(true);
    } else {
      throttledHandle.current = window.setTimeout(() => setBool(true), throttledTimeout);
    }
  };
  const setToFalse = instant => {
    if (throttledHandle.current) {
      window.clearTimeout(throttledHandle.current);
      throttledHandle.current = undefined;
    }
    if (instant) {
      setBool(false);
    } else {
      debouncedHandle.current = window.setTimeout(() => setBool(false), debouncedTimeout);
    }
  };
  return [bool, debouncedSetter];
};